import CapabilityFilterViewState from './schema/CapabilityFilterViewState';
import RoomListViewState from './schema/RoomListViewState';
import { RoomPanelMetricInfo } from './schema/RoomPanelMetricTypes';
import RoomPanelViewState from './schema/RoomPanelViewState';
import { RoomList, Room } from '../components/RoomSelector/RoomSelector.types';
import { CompositePickerStore } from 'owa-calendar-composite-picker';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

const defaultRoomListState: RoomListViewState = createDefaultRoomListViewState();

export const defaultRoomFilterState: CapabilityFilterViewState = {
    expandCapacity: false,
    expandFeature: false,
    expandFloor: false,
    selectedCapacity: null,
    selectedFloor: null,
    selectedFeatures: [],
    selectedFilters: null,
    selectedTags: [],
    shouldGetSpaces: false,
};

const defaultRoomPanelMetricsState: Partial<RoomPanelMetricInfo> = {
    totalNumSelectedCities: 0,
    totalNumSelectedRoomLists: 0,
    selectedFromSuggestion: false,
    selectedFromSearch: false,
    isFilterOpened: false,
    isFilterApplied: false,
    isCapacityFilterApplied: false,
    isFeatureFilterApplied: false,
    isFloorFilterApplied: false,
    isCapacityEnabled: false,
    isAudioEnabled: false,
    isDisplayEnabled: false,
    isVideoEnabled: false,
    isAccessibleEnabled: false,
    isFloorEnabled: false,
    queryStringChanged: false,
    isWorkspaceBookingEnabled: false,
};

function createDefaultRoomListViewState() {
    let userCurrentRoomList: RoomList;
    var userConfig = getUserConfiguration();
    if (userConfig?.ViewStateConfiguration) {
        userCurrentRoomList = {
            email: userConfig.ViewStateConfiguration.SchedulingLastUsedRoomListEmailAddress,
            name: userConfig.ViewStateConfiguration.SchedulingLastUsedRoomListName,
        };
    }

    return {
        currentRoomList: userCurrentRoomList,
        isSearchingForRooms: false,
        preferredRoomLists: [],
        roomLists: [],
        rooms: [],
        tagsIndex: new ObservableMap<string, Room[]>(),
        defaultRoomList: { ...userCurrentRoomList },
        selectedRoomList: userCurrentRoomList,
        showPlaceType: false,
    };
}

const defaultRoomListPickerViewState: CompositePickerStore = {
    options: [],
    filteredOptions: [],
    selectedOption: null,
    textFieldValue: '',
    navIndex: -1,
};

const defaultRoomPanelState: RoomPanelViewState = {
    roomFilterState: defaultRoomFilterState,
    roomPanelMetricsState: defaultRoomPanelMetricsState,
    roomListViewState: defaultRoomListState,
    opxRoomFinderData: null,
    roomListPickerViewState: defaultRoomListPickerViewState,
};

export const getStore = createStore<RoomPanelViewState>('roomPanelStore', defaultRoomPanelState);
export default getStore;
